import React from 'react'
import ExploreComp from '../../components/explore/ExploreComp'

const ExploreScreen = () => {
    return (
        <>
            <ExploreComp />
        </>
    )
}

export default ExploreScreen